import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as Type from "../../../../../../../../common-deprecated/styles/lexus/Type";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import {
    h1Style,
    bodyStyle,
    type TextStyleType,
} from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Wrapper = styled.div<{ dark?: boolean } & SpaceProps>`
    padding: 48px 0;
    background-color: ${({ dark }) => (dark ? theme.colors.mist : "transparent")};
    @media ${getBreakpoint("up", "md")} {
        padding: 75px 50px;
    }
    ${space};
`;

export const ActionList = styled.ul`
    margin: ${theme.space[4]}px 0;
    padding: 0;
`;

export const ActionItem = styled.li<TextStyleType>`
    display: flex;
    align-items: flex-start;
    margin-top: ${theme.space[3]}px;
    color: ${theme.colors.midnight};
    ${bodyStyle};

    strong {
        font-family: ${theme.fonts.regular};
    }

    svg {
        min-width: 20px;
        margin-top: 8px;
        margin-right: ${theme.space[2]}px;
        color: ${theme.colors.midnight};
    }

    html[dir="rtl"] & {
        svg {
            margin-left: ${theme.space[2]}px;
            margin-right: 0;
        }
    }
`;

export const Sidebar = styled(Flex.Col)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.white};

    @media ${getBreakpoint("only", "md")} {
        position: relative;
        &::before,
        &::after {
            display: block;
            position: relative;
            width: 160px; /* magic value */
            height: 100%;
            content: "";
            background-color: ${theme.colors.white};
        }

        &::before {
            left: -130px; /* magic value */
        }

        &::after {
            right: -130px; /* magic value */
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        justify-content: flex-start;
        background-color: transparent;
    }
`;

export const Panel = styled.div`
    width: 100%;
    padding: ${theme.spacer}px 0;
    padding-top: 0;
    background-color: ${theme.colors.mist};

    @media ${getBreakpoint("up", "lg")} {
        width: 375px;
        padding: ${theme.spacer}px;
        border-radius: 4px;
    }
`;

export const ImageWrapper = styled.div`
    max-width: 320px;
    margin-bottom: 46px;

    @media ${getBreakpoint("up", "md")} {
        max-width: none;
    }
`;

export const Title = styled(Type.H1)`
    margin-bottom: 46px;
    ${h1Style};
    color: ${theme.colors.midnight};
`;

export const BasketTitle = styled.h2<TextStyleType>`
    margin-bottom: ${theme.space[4]}px;
    text-align: start;
    color: ${theme.colors.midnight};
    ${bodyStyle};
`;

export const Description = styled.p<TextStyleType>`
    margin-bottom: ${theme.space[2]}px;
    color: ${theme.colors.platinumDark};
    ${bodyStyle};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${theme.space[4]}px;
    row-gap: ${theme.space[3]}px;

    ${Button.ButtonPrimary},
    ${Button.ButtonWithIcon} {
        font-size: 1.6rem;
    }
`;
